// extracted by mini-css-extract-plugin
export var copyIcon = "_yo-2";
export var discountCard = "_yo-0";
export var discountCode = "_yo-3";
export var discountContent = "_yo-1";
export var loadingCard = "_yo-4";